import dayjs from 'dayjs';
import { isArray, forEach, get } from 'lodash';
import { setDatabase, getDatabaseConfig, saveSettingApi } from '../api/database-api';
import { formatDate } from 'library-@/utils/dateFormat.js';

export const getDateFormatConfig = lang =>{
    const langConfig = {
        cn: 'YYYY-MM-DD',
        jp: 'YYYY-MM-DD',
        tw: 'YYYY-MM-DD',
        de: 'D MMM YYYY',
        en: 'D MMM YYYY'
    };
    return langConfig[lang] || langConfig.cn;
};

export const typeIsSavedQuery = 'savedQuery';

export const formatDateTime = (date, type = 'time') => {
    const currentLang = get(window, 'zPREFACE.lang');
    // 英文下去掉am pm 与analytics保持统一
    return formatDate({
        date: date,
        utcOffset: '',
        currentLang: currentLang,
        type: type
    });
};

export const isToday = date => {
    return date === formatDateTime(new Date(), 'date');
};

export const numberFormatUtil = number =>{
    let temp = parseFloat(number);
    if (temp > 999999999) {
        return `${Math.round(temp / 10000000) / 100}B`;
    }
    if (temp > 99999999) {
        return `${Math.round(temp / 1000000)}M`;
    }
    if (temp > 9999999) {
        return `${Math.round(temp / 100000) / 10}M`;
    }
    if (temp > 999999) {
        return `${Math.round(temp / 10000) / 100}M`;
    }
    if (temp > 99999) {
        return `${Math.round(temp / 1000)}K`;
    }
    if (temp > 9999) {
        return `${Math.round(temp / 100) / 10}K`;
    }
    return String(number).replace(/\B(?=(\d{3})+$)/g, ',');
};


export const HistoryQueryClassName = 'analytics-website__search-history';


export const getDefaultRangeDate = ()=>{
    return {
        start: dayjs(new Date()).subtract(1, 'months').startOf('day').valueOf(),
        end: dayjs(new Date()).endOf('day').valueOf()
    };
};

export const prepareDbApi = async ({ patentCountries, patentTypes })=>{
    let allDb = [];
    await getDatabaseConfig()
        .then(res => {
            const countries = res.patentCountries || {};
            forEach(countries, dbList => {
                allDb = allDb.concat(isArray(dbList) ? dbList : []);
            });
        })
        .catch(()=>{});
    if (!patentCountries && !allDb.length) {
        return Promise.resolve({});
    }
    return setDatabase({
        patentCountries: !patentCountries ? allDb : patentCountries.split(/,\s*/img),
        patentTypes
    });
};

export const prepareSettingApi = settings => {
    return saveSettingApi(settings);
};
